/* eslint-disable no-unused-vars */
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Checkbox } from 'antd';
import {
    handleProductInputArray,
    getProductCategories,
} from '../../redux/products/productsActions';
import DokanCard from '../card/DokanCard';
import RecursiveComponent from './RecursiveComponent';

function Categories() {
    const dispatch = useDispatch();
    const handleChangeInput = (name, value = '', e = null) => {
        dispatch(handleProductInputArray(name, value, e));
    };
    useEffect(() => {
        dispatch(getProductCategories());
    }, [dispatch]);
    const productCategories = useSelector((state) => state.products.productCategories);
    function getTreeData() {
        return productCategories.map((item) => ({
            ...item,
            hasChildren: productCategories.filter((i) => i.parent === item.id).length > 0,
        }));
    }

    const treeData = getTreeData();
    return (
        <>
            <DokanCard hasTitle cardTitle="Product Categories">
                <RecursiveComponent treeData={treeData} />
            </DokanCard>
        </>
    );
}

export default Categories;
